import { useRouter } from 'next/router';
import { GrispiInputProps } from '..';
import QuillGrispiRichTextEditor from '../../QuillGrispiRichTextEditor';
import GrispiInputContainer from '../GrispiInputContainer';

import { Input } from 'antd';
import { generateTicketFormNameForStorage } from '../../../store/childStore/tabStore';
import { getSelectedTabKeyFromUrl } from '../../../utils/routeHelper';

type GrispiTextAreaInputProps = Omit<GrispiInputProps<'TEXTAREA'>, 'type' | 'options' | 'isNewValueAllowed'>;

export default function GrispiTextAreaInput({
    containerProps,
    onChange,
    value,
    antdProps,
    ...rest
}: GrispiTextAreaInputProps) {
    return (
        <GrispiInputContainer {...containerProps}>
            <Input.TextArea
                allowClear
                {...antdProps}
                onChange={({ target: { value } }) => onChange(value || null)}
                value={value}
                {...rest}
            />
        </GrispiInputContainer>
    );
}
export function GrispiTempChatAreaInput({ containerProps, onChange, value, ...rest }: GrispiTextAreaInputProps) {
    const { asPath } = useRouter();
    return (
        <GrispiInputContainer {...containerProps}>
            <QuillGrispiRichTextEditor
                value={value}
                onChange={onChange}
                chatInput
                hideHtmlManipulationsOnToolbar
                eventListenerKey={`${generateTicketFormNameForStorage(getSelectedTabKeyFromUrl(asPath))}`}
                {...rest}
            />
        </GrispiInputContainer>
    );
}
